export const APP_SET_WINDOW_WIDTH = 'APP_SET_WINDOW_WIDTH';